
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkDocxOutputFormatEnum } from '../models/work-docx-output-format-enum';

export function getSendMessageAttachmentDtoFormGroup() {
return new FormGroup({
    fileName: new FormControl<string | undefined>('', [Validators.required]),
    projectId: new FormControl<number | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
    referralId: new FormControl<number | undefined>(undefined),
    debtorId: new FormControl<number | undefined>(undefined),
    creditorNumber: new FormControl<string | undefined>(''),
    withBackground: new FormControl<boolean | undefined>(false),
    format: new FormControl<WorkDocxOutputFormatEnum | undefined>(undefined),
    preparedToken: new FormControl<string | undefined>(undefined),
})
;
}
      